var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0238 12.7383H8.19043V2.25573H14.0238V12.7383Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56024 7.4974C8.56024 5.37073 9.55598 3.47678 11.1065 2.25608C9.97257 1.36336 8.54165 0.830729 6.98654 0.830729C3.3049 0.830729 0.320312 3.81547 0.320312 7.4974C0.320312 11.1792 3.3049 14.1641 6.98654 14.1641C8.54165 14.1641 9.97257 13.6314 11.1065 12.7386C9.55598 11.5179 8.56024 9.62391 8.56024 7.4974Z",
    fill: "#E71B25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8925 7.4974C21.8925 11.1792 18.9079 14.1641 15.2264 14.1641C13.6713 14.1641 12.2404 13.6314 11.1064 12.7386C12.6569 11.5179 13.6526 9.62391 13.6526 7.4974C13.6526 5.37073 12.6569 3.47678 11.1064 2.25608C12.2404 1.36336 13.6713 0.830729 15.2264 0.830729C18.9079 0.830729 21.8925 3.81547 21.8925 7.4974Z",
    fill: "#F79410"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6839 11.6289V11.3702H21.6163L21.5386 11.5481L21.461 11.3702H21.3934V11.6289H21.441V11.4338L21.5139 11.602H21.5634L21.6363 11.4333V11.6289H21.6839ZM21.256 11.6289V11.4143H21.3426V11.3707H21.1221V11.4143H21.2087V11.6289H21.256Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/masterCardIcon.c4953e395b6fb9ff1a5a6936feb0f6f4.svg";
export { ForwardRef as ReactComponent };